// extracted by mini-css-extract-plugin
module.exports = {"RequestDocument":"RequestDocument_RequestDocument__2GPuj","reading":"RequestDocument_reading__27abR"};